import {Component, Input} from '@angular/core';
import {FilterMatchMode, SelectItem} from 'primeng/api';
import {TableModule} from 'primeng/table';
import {InputComponent} from '../../../form/input/input.component';

@Component({
  selector: 'app-table-string-filter',
  templateUrl: './string-filter.component.html',
  imports: [
    TableModule,
    InputComponent
  ],
  styleUrls: ['./string-filter.component.scss']
})
export class StringFilterComponent {

  @Input() field: string = '';

  @Input() placeholder = '';

  defaultMatch = FilterMatchMode.CONTAINS;

  @Input()
  customMatchModeOptions!: SelectItem[];

  @Input() inputWidth = '200px';
}
